import React, { useState } from "react";
import { Link } from "react-router-dom";
import CreditsModal from "@/components/CreditsModal";

const BUILD_VERSION = process.env.REACT_APP_VERSION || "2.0";

export default function Footer({ onCreditsOpen, showTestAchievement, onTestAchievement }) {
  const [creditsOpen, setCreditsOpen] = useState(false);

  const handleCreditsOpen = () => {
    if (onCreditsOpen) onCreditsOpen();
    else setCreditsOpen(true);
  };

  return (
    <>
      <footer className="border-t border-[#EAE3D9] dark:border-[#2A2A2A] bg-[#FDFBF7] dark:bg-[#111111] mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#757169] dark:text-[#B8B2AA]">
          <div className="flex flex-wrap justify-center sm:justify-start gap-x-4 gap-y-1">
            <span className="font-medium text-[#4A4742] dark:text-[#D8D0C6]">Tavoli da Gioco</span>
            <span>Bibliocronache · Patrogames</span>
          </div>
          <a href="https://boardgamegeek.com" target="_blank" rel="noopener noreferrer" className="flex-shrink-0">
            <img
              src="/images/poweredbybgg.webp"
              alt="Powered by BGG"
              className="h-8 opacity-70 hover:opacity-100 transition-opacity"
            />
          </a>
          <div className="flex flex-wrap justify-center sm:justify-end gap-x-4 gap-y-1">
            <Link to="/privacy" className="hover:text-[#2B593F] dark:hover:text-[#8FC79F] underline-offset-2 hover:underline">Privacy Policy</Link>
            <Link to="/cookies" className="hover:text-[#2B593F] dark:hover:text-[#8FC79F] underline-offset-2 hover:underline">Cookie Policy</Link>
            <Link to="/termini" className="hover:text-[#2B593F] dark:hover:text-[#8FC79F] underline-offset-2 hover:underline">Termini</Link>
            <a href="mailto:info@tavolidagioco.eu" className="hover:text-[#2B593F] dark:hover:text-[#8FC79F] underline-offset-2 hover:underline">Contatti</a>
            <button
              onClick={handleCreditsOpen}
              className="text-[#C8553D] dark:text-[#F08A78] hover:text-[#A6432E] dark:hover:text-[#FFB0A2] transition-colors underline-offset-2 hover:underline"
            >
              Credits
            </button>
            {showTestAchievement && (
              <button
                onClick={onTestAchievement}
                className="text-[#2B593F] dark:text-[#8FC79F] hover:text-[#1E3F2C] dark:hover:text-[#B7E3C2] transition-colors underline-offset-2 hover:underline"
              >
                Test achievement
              </button>
            )}
            <span className="text-[#B0A898] dark:text-[#4A4742]">v{BUILD_VERSION}</span>
          </div>
        </div>
      </footer>
      <CreditsModal open={creditsOpen} onClose={() => setCreditsOpen(false)} />
    </>
  );
}
